import {Component, Input, OnInit} from '@angular/core';
import {Constants} from "../../../utils/constants";

@Component({
  selector: 'app-ohe-show',
  templateUrl: './ohe-show.component.html',
  styleUrls: ['./ohe-show.component.scss']
})
export class OheShowComponent implements OnInit {

  @Input() openingHoursElements:any;

  elements: any;

  constructor() { }

  ngOnInit() {
    this.initElements();
    Object.keys(this.openingHoursElements).forEach(key => {
      let elementsKey = Math.floor(+key/10)*10;
      this.elements.get(elementsKey).elementParts.push(this.openingHoursElements[key]);
      this.elements.get(elementsKey).type = this.openingHoursElements[key].type;
    });
  }

  initElements(){
    this.elements = new Map();
    this.elements.set(10, {name: 'general.monday', type:Constants.OPENING_HOURS_ELEMENT_TYPE.CLOSE, elementParts: []});
    this.elements.set(20, {name: 'general.tuesday', type:Constants.OPENING_HOURS_ELEMENT_TYPE.CLOSE, elementParts: []});
    this.elements.set(30, {name: 'general.wednesday', type:Constants.OPENING_HOURS_ELEMENT_TYPE.CLOSE, elementParts: []});
    this.elements.set(40, {name: 'general.thursday', type:Constants.OPENING_HOURS_ELEMENT_TYPE.CLOSE, elementParts: []});
    this.elements.set(50, {name: 'general.friday', type:Constants.OPENING_HOURS_ELEMENT_TYPE.CLOSE, elementParts: []});
    this.elements.set(60, {name: 'general.saturday', type:Constants.OPENING_HOURS_ELEMENT_TYPE.CLOSE, elementParts: []});
    this.elements.set(70, {name: 'general.sunday', type:Constants.OPENING_HOURS_ELEMENT_TYPE.CLOSE, elementParts: []});
  }

}
